module.exports = __webpack_public_path__ + "img/cause_3.2f21946d.svg";